import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import classes from './classes.module.scss';

const SwiperFullScreen = ({ open, onClose, moment }) => {
    return (
        <Modal open={open} onClose={onClose} className={classes.modal}>
            <Box className={classes.paper} >
                {
                    moment && (
                        moment.is_video ? (
                            <video className={classes.moment} controls>
                                <source src={moment.src} type="video/mp4" />
                            </video>
                        ) : (
                            <img src={moment.src} className={classes.moment} />
                        )
                    )
                }
            </Box>
        </Modal>
    );
};

export default SwiperFullScreen;